<template>
  <div>
    <md-button class="md-raised" @click="pauseAll" >{{ $t('Pause all') }}</md-button>
    <md-button class="md-raised" @click="resumeAll" >{{ $t('Resume all') }}</md-button>

    <basic-table
        v-if="userSubscriptions"
        :items="userSubscriptions"
        :fields="userSubscriptionsFields"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        @ClickOnPauseButton="ClickOnPauseButton"
        @ClickOnPlayButton="ClickOnPlayButton"
        :isPause="true"
        :isPlay="true"
        :isDelete="false"
        :isEdit="false"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
  </div>
</template>

<script>

export default {
  data () {
    return {
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      userSubscriptionsFields: [
        {key: 'packet.name', label: 'name', sortable: true},
        {key: 'packet.price', label: 'price', sortable: true},
        {key: 'packet.base', label: 'base', sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'start_at', label: 'start', sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'end_at', label: 'end', sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      options: {
        isShowAddButton: true
      }
    }
  },
  props: {
    userInfo: null
  },
  computed: {
    userSubscriptions () {
      return this.$store.getters['Settings/TV_24_USER_SUBSCRIPTIONS']
    }
  },
  methods: {
    editItem (item) {
      this.selectedUser = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEdit24TVUser', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {

    },
    resumeAll () {
      let tmp = {
        user_id: this.userInfo.id
      }
      let response = this.$store.dispatch('Settings/RESUME_ALL_TV_24_USER_SUBSCRIPTION', tmp)
      response.then(response => {
        this.$store.dispatch('Settings/GET_TV_24_USER_SUBSCRIPTIONS', this.userInfo.id)
        this.$root.$emit('makeToasts')
      })
    },
    pauseAll () {
      let tmp = {
        user_id: this.userInfo.id
      }
      let response = this.$store.dispatch('Settings/PAUSE_ALL_TV_24_USER_SUBSCRIPTION', tmp)
      response.then(response => {
        this.$store.dispatch('Settings/GET_TV_24_USER_SUBSCRIPTIONS', this.userInfo.id)
        this.$root.$emit('makeToasts')
      })
    },
    ClickOnPauseButton (item) {
      let tmp = {
        subscription_id: item.id,
        user_id: this.userInfo.id
      }
      let response = this.$store.dispatch('Settings/PAUSE_TV_24_USER_SUBSCRIPTION', tmp)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Settings/GET_TV_24_USER_SUBSCRIPTIONS', this.userInfo.id)
          this.$root.$emit('makeToasts')
        }
      })
    },
    ClickOnPlayButton (item) {
      let tmp = {
        subscription_id: item.id,
        user_id: this.userInfo.id,
        pause_id: item.pauses[0].id
      }
      let response = this.$store.dispatch('Settings/RESUME_TV_24_USER_SUBSCRIPTION', tmp)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Settings/GET_TV_24_USER_SUBSCRIPTIONS', this.userInfo.id)
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  watch: {
    userInfo: function (val) {
      if (val) {
        this.$store.dispatch('Settings/GET_TV_24_USER_SUBSCRIPTIONS', val.id)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customerPortal/24tv/userInfoSubs.vue